import { SMALL, EXTRA_EXTRA_SMALL, EXTRA_SMALL, MEDIUM, LARGE, EXTRA_LARGE } from '../../constants/sizes';
export const AVATAR_SIZES = {
  [EXTRA_EXTRA_SMALL]: 16,
  [EXTRA_SMALL]: 24,
  [SMALL]: 32,
  [MEDIUM]: 48,
  [LARGE]: 72,
  [EXTRA_LARGE]: 108
};